import createAction from "./utils/createMetaAction";
import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
export const propertiesViewTabUpdate = createAction("propertiesViewTabUpdate");
export default createMergedDefaultStateReducer(
  {
    [propertiesViewTabUpdate]: (state, tabId, selectedAnnotationOrAnnotationId) => {
      return {
        ...state,
        selectedAnnotationId: selectedAnnotationOrAnnotationId ? selectedAnnotationOrAnnotationId.id || selectedAnnotationOrAnnotationId : void 0,
        tabId
      };
    }
  },
  {
    tabId: "general"
  }
);
